<script setup lang="ts">
import router from '@/router';
import { ref, reactive, onMounted } from 'vue';

interface Props {
  collapsed: boolean;
}

const props = defineProps<Props>();

const emits = defineEmits(['update:collapsed']);

const collapsedClick = () => {
  emits('update:collapsed', !props.collapsed);
};

const logoutClick = () => {
  router.push('/login');
};
</script>

<template>
  <div class="header">
    <img
      v-if="!props.collapsed"
      src="@/assets/svg/unextand.svg?url"
      class="w-[20px] h-[20px] cursor-pointer"
      @click="collapsedClick"
    />

    <img
      v-else
      src="@/assets/svg/extand.svg?url"
      class="w-[20px] h-[20px] cursor-pointer"
      @click="collapsedClick"
    />

    <a-dropdown :trigger="['click']">
      <div class="avatar cursor-pointer">
        <img
          src="@/assets/logo.png?url"
          alt=""
        />
      </div>
      <template #overlay>
        <a-menu class="flex flex-col items-center justify-center gap-[4px] !bg-[#272727] !p-[8px]">
          <a-menu-item
            @click="logoutClick"
            class="!h-[40px] !w-[88px] cursor-pointer !p-0 text-center text-[14px] !text-[#fff]"
          >
            退出登录
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .avatar {
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
}
</style>
